<mat-icon [class.text-danger]="status() === 'has-theft'" aria-hidden="true"> visibility </mat-icon>
